import { createPortal } from 'react-dom';

const PreviewPortal = ({ children }) => createPortal(children, document.body);

export default PreviewPortal;
